// Shared info-tooltip affordance: a small muted (i) button that reveals
// explanatory copy on hover/focus. Extracted from MetricCard so the same
// pattern (icon, a11y, touch-target overlay, focus ring) is reused across
// KPI cards, channel tables, and the platform leaderboard.

import type { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export interface InfoTooltipProps {
  /** Used for the button's accessible name: `About ${label}`. */
  label: string;
  /** Tooltip body. */
  children: ReactNode;
  /** Side the tooltip opens on. Default "top". */
  side?: "top" | "right" | "bottom" | "left";
}

export function InfoTooltip({ label, children, side = "top" }: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={`About ${label}`}
          className="relative inline-flex size-4 items-center justify-center text-neutral-400 transition-colors hover:text-purple-700 focus-visible:text-purple-700 focus-visible:outline-2 focus-visible:outline-purple-500 focus-visible:outline-offset-2"
        >
          <i className="fa-regular fa-circle-info text-xs" aria-hidden="true" />
          <span
            aria-hidden="true"
            className="pointer-fine:hidden absolute top-1/2 left-1/2 size-[max(100%,3rem)] -translate-1/2"
          />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side}>{children}</TooltipContent>
    </Tooltip>
  );
}
